// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"f2c870d3","211":"0344ba08"}[chunkId] + ".chunk.js";
};